export default [{
    path: "/face-poster",
    name: "face-poster",
    component: () => import("@simple/views/face/page/poster.vue"),
}, ];